<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-02-24 10:49:14
-->
<template>
  <div class="header-query">
    <div class="sub-item">
      <el-radio v-model="type" v-if="type !== 'day'" label="year">年</el-radio>
      <el-radio v-model="type" v-if="type !== 'day'" label="month">月</el-radio>
      <el-radio v-if="type == 'day'" v-model="type" label="day">日</el-radio>
      <el-date-picker size="mini" v-show="type == 'year'" v-model="date" type="year" format="yyyy" value-format="yyyy"
        :clearable="false" placeholder="请选择年份" :picker-options="pickerOptions" @change="changedDate">
      </el-date-picker>
      <el-date-picker size="mini" v-show="type == 'month'" v-model="date" :clearable="false" type="month" format="yyyy-MM"
        value-format="yyyy-MM" placeholder="请选择月份" :picker-options="pickerOptions" @change="changedDate">
      </el-date-picker>
      <el-date-picker v-show="type == 'day'" size="mini" v-model="date" :clearable="false" type="date" format="yyyy-MM-dd"
        value-format="yyyy-MM-dd" placeholder="请选择" :picker-options="pickerOptions" @change="changedDate">
      </el-date-picker>
    </div>
  </div>
</template>

<script>
export default {
  name: "header-query",
  props: {
    defaultYear: {
      type: String,
    },
  },
  data() {
    return {
      oldType: "",
      type: "",
      date: "",
      year: "",
      // isPresident: true, // 是否总裁桌面
      pickerOptions: {
        // 超出当前年份或月份不可选
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  computed: {},
  methods: {
    changedDate(value) {
      this.$emit("changedDate", value);
    },
  },
  components: {},
  beforeMount() {
    // 模板编译/挂载之前
  },
  mounted() {
    // 模板编译/挂载之后
  },
  created() {
    // 初始化默认为年
    this.type = "year";
  },
  beforeUpdate() {
    // 组件更新之前
  },
  updated() {
    // 组件更新之后
  },
  beforeDestroy() {
    // 组件销毁前调用
    // Tips：你确认删除XX吗？
  },
  destroyed() {
    // 组件销毁后调用
    // Tips：当前组件已被删除，清空相关内容
  },
  // 数据监听
  watch: {
    defaultYear(value) {
      this.year = value;
      if (this.type === "year") {
        this.date = this.year;
        this.changedDate(this.date);
      }
    },
    type: function (value) {
      if (value === "year") {
        // 获取当前年份
        this.date = this.year ? this.year : String(new Date().getFullYear());
      } else if (value === "month") {
        // 获取当前月份
        const year = new Date().getFullYear();
        let month = new Date().getMonth() + 1;
        month = month < 10 ? "0" + month : month;
        this.date = `${year}-${month}`;
      } else if (value === "day") {
        // 获取当前日份
        const year = new Date().getFullYear();
        let month = new Date().getMonth() + 1;
        let day = new Date().getDate();
        month = month < 10 ? "0" + month : month;
        day = day < 10 ? "0" + day : day;
        this.date = `${year}-${month}-${day}`;
      }
      this.oldType = this.type;
      this.changedDate(this.date);
    },
    $route(newVal, oldVal) {
      // 如果是日桌面的图表 移除年月选择器的选项
      const name = this.$route.name;
      // this.isPresident = name == "ym" || name == "yc" ? true : false;
      if (name.indexOf("day-") > -1) {
        this.type = "day";
      } else {
        if (oldVal.name && oldVal.name.indexOf("day-") === -1) {
          this.type = this.oldType;
        } else {
          this.type = "year";
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.header-query {
  width: auto;
  display: inline-block;
  position: absolute;
  left: 58px;

  .sub-item {
    width: 100%;
    height: 100%;
    display: flex;
  }

  /deep/.el-radio__input.is-checked .el-radio__inner {
    border-color: #fff;
    background: transparent;
  }

  /deep/.el-radio__inner {
    border: 1px solid #dcdfe6;
    border-radius: 100%;
    width: 14px;
    height: 14px;
    cursor: pointer;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  /deep/.el-radio__inner::after {
    width: 6px;
    height: 6px;
    border-radius: 100%;
    background-color: #fff;
  }

  /deep/.el-radio__label {
    font-size: 14px;
    padding-left: 4px;
    color: #fff;
  }

  /deep/.el-radio__input.is-checked+.el-radio__label {
    color: #fff;
  }

  /deep/.el-radio {
    color: #606266;
    font-weight: 500;
    cursor: pointer;
    margin-right: 25px;
    margin-top: 32px;
  }

  /deep/.el-input--mini .el-input__inner {
    height: 28px;
    line-height: 28px;
    background: transparent;
    border-color: transparent;
    outline: none;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);

    &:focus,
    &:hover {
      border-color: #fff;
    }
  }

  /deep/.el-input--mini .el-input__icon {
    line-height: 28px;
    font-size: 14px;
    color: #fff;
  }

  /deep/.el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 150px;
  }
}
</style>